import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const ValorAplicacionArticulo76 = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Aplicacion Articulo 76' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='valorAplicacionArticulo76'>
          {({ field }) => <Form.InputText {...field} id='input-valorAplicacionArticulo76' isInvalid={iError && iTouched} disabled={fIsSubmitting} />}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ValorAplicacionArticulo76)
